module.exports = __webpack_public_path__ + "img/pixeos_pixeos1token.d7122f5.png";